import { Dispatch, SetStateAction } from "react";
import { useLocalStorage } from "usehooks-ts";

interface UseCookiesConsentReturn {
  cookiesConsent: boolean | undefined;
  setCookiesConsent: Dispatch<SetStateAction<boolean | undefined>>;
}

export function useCookiesConsent(): UseCookiesConsentReturn {
  const [cookiesConsent, setCookiesConsent] = useLocalStorage<
    boolean | undefined
  >("cookiesConsent", undefined);

  return { cookiesConsent, setCookiesConsent };
}
